// puts the api response data in the correct format for the data wells to consume
export const transformChangeValuesFromResponse = ({
  companyCurrency,
  response,
  rollUp
}) => {
  const currencyCode = response.currencyCode;
  const isTooEarlyInPeriod = !response.isValidOverTimeComparisonWindow;
  return {
    currencyCode: currencyCode || companyCurrency,
    change: rollUp.amountChange,
    currentAmount: rollUp.currentAmount,
    isTooEarlyInPeriod,
    percentChange: rollUp.amountChangePercentage,
    previousAmount: rollUp.previousAmount
  };
};